import { render, staticRenderFns } from "./CourseAgreementsAdmin.vue?vue&type=template&id=1665d013&scoped=true"
import script from "./CourseAgreementsAdmin.vue?vue&type=script&lang=js"
export * from "./CourseAgreementsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1665d013",
  null
  
)

export default component.exports